goog.provide("shadow.js.shim.module$$mui$material$Popover$default");
shadow.js.shim.module$$mui$material$Popover$default = shadow.js.shim.module$$mui$material$Popover.default;
